import { StoredValueExpirationScheduleFragment } from '@occc/graphql';
import { DateTimeFormat, formatDateTime, parseDate } from '@occc-app/lib/date';
import { formatMoneyAmount } from '@occc-app/lib/currency';
import { TableField } from '@occc/ui-design-system';

export const storedValueExpirationTableMessages = {
  expirationDate: 'Expiration Date',
  dollarAmount: 'Dollar Amount',
};

export const formatExpirationTableDate = (date: string | null | undefined) => {
  if (!date) return '-';
  return formatDateTime(parseDate(date), DateTimeFormat.DateWithYear);
};

export const makeStoredValueExpirationFields = (
  row: StoredValueExpirationScheduleFragment,
): TableField[] => {
  const { expirationDate, storedValue } = row;

  return [
    {
      label: storedValueExpirationTableMessages.expirationDate,
      value: formatExpirationTableDate(expirationDate),
    },
    {
      label: storedValueExpirationTableMessages.dollarAmount,
      value: formatMoneyAmount(storedValue, { fromCents: true }),
      align: 'right',
    },
  ];
};
